// CollapsibleServiceTable.tsx
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import MainLayout from "@/components/layouts";
import { Camera, ChevronRight, List, MoreHorizontal, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useState } from "react";
import { PageHeader } from "@/components/layouts/page-header/index.tsx";

const serviceData = [
  {
    parent: "Cleaning Services",
    subServices: [
      { name: "1 Bedroom - Standard Clean", rate: "$100", payment: "$75" },
      { name: "2 Bedroom - Standard Clean", rate: "$120", payment: "$90" },
      { name: "3 Bedroom - Standard Clean", rate: "$140", payment: "$105" },
      { name: "Deep Clean", rate: "$160", payment: "$120" },
      { name: "Move-out Clean", rate: "$180", payment: "$135" },
    ],
  },
  {
    parent: "Painting",
    subServices: [
      { name: "1 Room Paint", rate: "$150", payment: "$100" },
      { name: "2 Rooms Paint", rate: "$280", payment: "$190" },
      { name: "Full Apartment Paint", rate: "$600", payment: "$420" },
      { name: "Accent Wall", rate: "$80", payment: "$60" },
      { name: "Touch Ups", rate: "$50", payment: "$35" },
    ],
  },
  {
    parent: "Graffiti Removal",
    subServices: [
      { name: "Small Area", rate: "$80", payment: "$60" },
      { name: "Medium Area", rate: "$150", payment: "$110" },
      { name: "Large Area", rate: "$250", payment: "$180" },
      { name: "Garage Cleanup", rate: "$200", payment: "$150" },
      { name: "Wall Paintover", rate: "$300", payment: "$220" },
    ],
  },
  {
    parent: "Snow Cleaning",
    subServices: [
      { name: "Sidewalk", rate: "$60", payment: "$45" },
      { name: "Driveway", rate: "$90", payment: "$65" },
      { name: "Parking Lot", rate: "$200", payment: "$140" },
      { name: "Stairs", rate: "$40", payment: "$30" },
      { name: "Full Premises", rate: "$300", payment: "$210" },
    ],
  },
];

export default function Services() {
  const breadcrumb = [{ name: "Services", href: "#" }];
  const [openedServices, setOpenedServices] = useState(["Cleaning Services"] as string[]);

  function handleToggleService(service: string) {
    if (openedServices.includes(service)) {
      setOpenedServices(openedServices.filter((s) => s !== service));
    } else {
      setOpenedServices([...openedServices, service]);
    }
  }

  return (
    <MainLayout breadcrumb={breadcrumb}>
      <PageHeader title="Services" subtitle="Manage your services" buttonText="Add Service" onButtonClick={() => {}} />
      <div className="p-0">
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Service</TableHead>
              <TableHead>Rate of Service</TableHead>
              <TableHead>Individual Payment</TableHead>
              <TableHead>Actions</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {serviceData.map((service) => (
              <>
                <TableRow>
                  <TableCell colSpan={3} className="bg-muted font-medium">
                    <div
                      className="flex items-center gap-2 cursor-pointer"
                      onClick={() => handleToggleService(service.parent)}
                    >
                      <ChevronRight
                        className={`h-4 w-4 transition-transform duration-300 ${
                          openedServices.includes(service.parent) ? "rotate-90" : ""
                        }`}
                      />
                      {service.parent}
                    </div>
                  </TableCell>
                  <TableCell className="bg-muted font-medium">
                    <DropdownMenu>
                      <DropdownMenuTrigger>
                        <Button variant="ghost">
                          <MoreHorizontal />
                        </Button>
                      </DropdownMenuTrigger>
                      <DropdownMenuContent>
                        <DropdownMenuItem>
                          <Plus className="mr-2" /> Add Sub Service
                        </DropdownMenuItem>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem variant="destructive">
                          <Trash2 className="mr-2" /> Remove
                        </DropdownMenuItem>
                      </DropdownMenuContent>
                    </DropdownMenu>
                  </TableCell>
                </TableRow>

                {openedServices.includes(service.parent) && (
                  <>
                    {service.subServices.map((sub, i) => (
                      <TableRow key={i}>
                        <TableCell>{sub.name}</TableCell>
                        <TableCell>{sub.rate}</TableCell>
                        <TableCell>{sub.payment}</TableCell>
                        <TableCell>
                          <DropdownMenu>
                            <DropdownMenuTrigger>
                              <Button variant="ghost">
                                <MoreHorizontal />
                              </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent>
                              <DropdownMenuItem>
                                <Camera className="mr-2" /> Manage Photo Tasks
                              </DropdownMenuItem>
                              <DropdownMenuItem>
                                <List className="mr-2" /> Manage Task List
                              </DropdownMenuItem>
                              <DropdownMenuSeparator />
                              <DropdownMenuItem variant="destructive">
                                <Trash2 className="mr-2" /> Remove Sub Serivce
                              </DropdownMenuItem>
                            </DropdownMenuContent>
                          </DropdownMenu>
                        </TableCell>
                      </TableRow>
                    ))}
                  </>
                )}
              </>
            ))}
          </TableBody>
        </Table>
      </div>
    </MainLayout>
  );
}
